import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-primary-600 to-accent-600 p-10 md:p-16 text-center">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.15),transparent_60%)]"></div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
              准备好开始你的韩漫之旅了吗？
            </h2>
            <p className="text-white/80 text-sm md:text-base max-w-lg mx-auto mb-8">
              加入数百万韩漫爱好者，畅享无删减下拉式韩国漫画，免费阅读海量优质内容
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white text-primary-600 rounded-full font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
              >
                开始阅读
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}